import React from 'react'
import { graphql } from 'gatsby'
import style from './steps.mod.scss'
import { Content, Button } from '@components'

const Steps = props => {
  const stepArray = [1, 2, 3].map(step => ({
    title: props[`step${step}Title`],
    icon: props[`step${step}Icon`],
    caption: props[`step${step}CaptionNode`]
  }))

  return (
    <div className={style.steps}>
      <div className={style.steps__wrap}>
        {stepArray.map((step, i) => (
          <div className={style.steps__step} key={`steps-step-${i}`}>
            <div className={style.steps__circle}>
              <img src={step.icon.url} alt={step.title} />
            </div>
            <div className={style.steps__content}>
              <h4>{step.title}</h4>
              <Content
                contentNode={step.caption}
                addLastMargin={
                  props.blurb || props.link?.link?.path || props.link?.url
                }
              />
            </div>
          </div>
        ))}
      </div>
      {props.blurb && <p className={style.steps__blurb}>{props.blurb}</p>}
      {(props.link?.link?.path || props.link?.url) && (
        <Button centered={true} to={props.link?.link?.path || props.link.url}>
          {props.link.displayText}
        </Button>
      )}
    </div>
  )
}

export default Steps

export const query = graphql`
  fragment Steps on DatoCmsStepsToJoin {
    id
    background
    backgroundStyle
    padding
    heading
    leadNode {
      childMarkdownRemark {
        html
      }
    }
    model {
      apiKey
    }
    blurb
    link {
      ...Link
    }
    step1Title
    step1Icon {
      url
    }
    step1CaptionNode {
      childMarkdownRemark {
        html
      }
    }
    step2Title
    step2Icon {
      url
    }
    step2CaptionNode {
      childMarkdownRemark {
        html
      }
    }
    step3Title
    step3Icon {
      url
    }
    step3CaptionNode {
      childMarkdownRemark {
        html
      }
    }
  }
`
